export default __webpack_public_path__ + "static/media/bluefolder.731e649d.svg";